import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FilterSelect from '../../components/FilterSelect';
import * as shortlistActions from '../../actions/shortlist';
import {
    shortlistStateKey,
    isCommonFilterDisabled
} from '../../helpers/shortlistUtils';

class PedigreeFilters extends PureComponent {
    static propTypes = {
        refinement: PropTypes.shape({
            sireName: PropTypes.string,
            damName: PropTypes.string,
            sireOfDamName: PropTypes.string,
        }).isRequired,
        data: PropTypes.shape({
            sireNameOptions: PropTypes.array.isRequired,
            damNameOptions: PropTypes.array.isRequired,
            sireOfDamNameOptions: PropTypes.array.isRequired
        }).isRequired,
        loadSireNameOptions: PropTypes.func.isRequired,
        loadDamNameOptions: PropTypes.func.isRequired,
        loadSireOfDamNameOptions: PropTypes.func.isRequired,
        applyShortlistSireNameFilter: PropTypes.func.isRequired,
        applyShortlistDamNameFilter: PropTypes.func.isRequired,
        applyShortlistSireOfDamNameFilter: PropTypes.func.isRequired
    };

    isCommonFilterDisabled() {
        return isCommonFilterDisabled(this.props.refinement);
    }

    handleSireNameChange = (event) => {
        this.props.applySearchResultsSireNameFilter(event.target.value);
    };

    handleDamNameChange = (event) => {
        this.props.applySearchResultsDamNameFilter(event.target.value);
    };

    handleDamSireChange = (event) => {
        this.props.applySearchResultsSireOfDamNameFilter(event.target.value);
    };

    render() {
        const {
            refinement: {
                sireName,
                damName,
                sireOfDamName
            },
            data: {
                sireNameOptions,
                damNameOptions,
                sireOfDamNameOptions
            },
            loadSireNameOptions,
            loadDamNameOptions,
            loadSireOfDamNameOptions,
            applyShortlistSireNameFilter,
            applyShortlistDamNameFilter,
            applyShortlistSireOfDamNameFilter
        } = this.props;
        return (
            <div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Sire</span>
                    <FilterSelect
                        title="Sire"
                        alphabet
                        showSearch
                        disabled={this.isCommonFilterDisabled()}
                        value={sireName}
                        options={sireNameOptions}
                        onPopoverDidOpen={loadSireNameOptions}
                        onChange={applyShortlistSireNameFilter}
                    />
                </div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Dam</span>
                    <FilterSelect
                        title="Dam"
                        alphabet
                        showSearch
                        disabled={this.isCommonFilterDisabled()}
                        value={damName}
                        options={damNameOptions}
                        onPopoverDidOpen={loadDamNameOptions}
                        onChange={applyShortlistDamNameFilter}
                    />
                </div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Dam's Sire</span>
                    <FilterSelect
                        title="Dam's Sire"
                        alphabet
                        showSearch
                        disabled={this.isCommonFilterDisabled()}
                        value={sireOfDamName}
                        options={sireOfDamNameOptions}
                        onPopoverDidOpen={loadSireOfDamNameOptions}
                        onChange={applyShortlistSireOfDamNameFilter}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { refinement, data } = state[shortlistStateKey];
    return {
        refinement,
        data
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(shortlistActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PedigreeFilters);



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/PedigreeFiltersShortlist.js